// assets/custom-recommendations.js
async function fetchJSON(url, opts) {
  const res = await fetch(url, opts);
  if (!res.ok) throw new Error(`${res.status} ${res.statusText}`);
  return res.json();
}

async function getRecommendations(productId, shopDomain, storefrontToken, opts = {}) {
  const limit = opts.limit || 20;
  let recData;
  try {
    recData = await fetchJSON(`/recommendations/products.json?product_id=${productId}&limit=${limit}`);
  } catch (e) {
    console.warn('Error fetching native recommendations', e);
    recData = { products: [] };
  }

  const blockedTags = opts.blockedTags || ['hidden','no-recommend','draft'];
  const requiredTags = opts.requiredTags || []; // e.g.: ['featured']

  let products = (recData.products || []).filter(p => {
    const isAvailable =
      p.available === undefined
        ? (p.variants && p.variants.some(v => v.available))
        : p.available;
    if (!isAvailable) return false;

    const productTags = (p.tags || []).map(tag => tag.toLowerCase());
    const blocked = (blockedTags || []).map(t => t.toLowerCase());
    const required = (requiredTags || []).map(t => t.toLowerCase());

    const hasBlocked = productTags.some(tag => blocked.includes(tag));
    if (hasBlocked) return false;

    if (required.length > 0) {
      const hasRequired = productTags.some(tag => required.includes(tag));
      return hasRequired;
    }

    return true;
  });

  if (products.length < (opts.min || 4)) {
    try {
      const gqlParts = [];

      const productTags = (opts.product_tags || '')
        .split(',')
        .map(t => t.trim().toLowerCase())
        .filter(Boolean);

      const hasWomenTag = productTags.some(t => ['women', 'womens', 'woman'].includes(t));

      gqlParts.push(`available_for_sale:true`);

      if (opts.product_vendor) {
        gqlParts.push(`vendor:'${opts.product_vendor.replace(/'/g, "\\'")}'`);
      }

      if (opts.product_type) {
        gqlParts.push(`product_type:'${opts.product_type.replace(/'/g, "\\'")}'`);
      }

      // Exclude women-related products if current product is NOT women
      if (!hasWomenTag) {
        gqlParts.push(`-tag:'women'`);
        gqlParts.push(`-tag:'womens'`);
        gqlParts.push(`-tag:'woman'`);
      }

      const queryString = gqlParts.join(' AND ');
      console.log(queryString, 'queryString');

      // const gql = `{
      //   products(first: ${limit}, query: "${queryString}") {
      //     edges {
      //       node {
      //         id
      //         handle
      //         title
      //         tags
      //         onlineStoreUrl
      //         images(first:1){ edges{ node{ url } } }
      //         variants(first:1){
      //           edges{
      //             node{
      //               price{
      //                 amount
      //                 currencyCode
      //               }
      //               availableForSale
      //             }
      //           }
      //         }
      //       }
      //     }
      //   }
      // }`;

const gql = `{
  products(first: ${limit}, query: "${queryString}") {
    edges {
      node {
        id
        handle
        title
        tags
        availableForSale
        totalInventory
        onlineStoreUrl
        images(first:1){ edges{ node{ url } } }
        variants(first:10){
          edges{
            node{
              availableForSale
              price{
                amount
                currencyCode
              }
            }
          }
        }
      }
    }
  }
}`;


      const gqlRes = await fetch(`https://${shopDomain}/api/2024-10/graphql.json`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': storefrontToken
        },
        body: JSON.stringify({ query: gql })
      });

      const gqlData = await gqlRes.json();
      console.log('TEST ', gqlData);
      const gqlProducts = (gqlData?.data?.products?.edges || [])
  .map(e => e.node)
  .filter(node => node.onlineStoreUrl) // 👈 solo productos con URL en la Online Store
  .map(node => {
    const variants = node.variants?.edges || [];
    const firstVariant = variants[0]?.node;

    return {
      id: node.id,
      handle: node.handle,
      title: node.title,
      tags: node.tags,
      url: node.onlineStoreUrl || `/products/${node.handle}`,
      featured_image: node.images?.edges?.[0]?.node?.url || null,
      price: firstVariant?.price || null,
      available: true
    };
  });


      const existingHandles = new Set(products.map(p => p.handle));
      for (const gp of gqlProducts) {
        if (!existingHandles.has(gp.handle)) products.push(gp);
      }
    } catch (e) {
      console.warn('Error fallback GraphQL', e);
    }
  }
  
  return products.slice(0, opts.take || 8);
}

async function renderRecommendationsInto(containerSelector, products) {
  const container = document.querySelector(containerSelector);
  if (!container) return;

  // Clear previous content
  container.innerHTML = '';

  if (!products || !products.length) {
    return;
  }

  // Ensure <ul> exists
  let list = container.querySelector('[data-custom-recs-list]');
  if (!list) {
    list = document.createElement('ul');
    list.className = 'product-list';
    list.setAttribute('data-custom-recs-list', '');
    container.appendChild(list);
  }

  // 🔹 Build all fetch promises in parallel
  const promises = products.map(p => {
    const handle = p.handle;
    if (!handle) return null;

    const url = `/products/${encodeURIComponent(handle)}?section_id=render-product-item`;
    console.log('FETCH CARD URL', url);

    return fetch(url)
      .then(res => {
        if (!res.ok) {
          console.error('Failed to fetch card section for', handle, res.status);
          return null;
        }
        return res.text();
      })
      .then(html => {
        if (!html) return null;
        const temp = document.createElement('div');
        temp.innerHTML = html;
        const item = temp.querySelector('[data-product-item]');
        if (!item) {
          console.warn('No [data-product-item] found for', handle);
          return null;
        }
        return item;
      })
      .catch(e => {
        console.error('Error fetching card section for', handle, e);
        return null;
      });
  }).filter(Boolean); // remove nulls for products without handle

  // 🔹 Wait for ALL product cards
  const items = (await Promise.all(promises)).filter(Boolean);

  // Nothing valid? bail
  if (!items.length) return;

  // 🔹 Append all at once with a fragment (one paint)
  const frag = document.createDocumentFragment();
  items.forEach(item => frag.appendChild(item));
  list.appendChild(frag);

  console.log('before init product card');

  // Re-init product card JS behavior using Atlantic's own class
  waitForProductItem(function () {
    initProductCards(container);
  });

  // Re-init accelerated checkout buttons if available
  if (window.Shopify && Shopify.PaymentButton) {
    Shopify.PaymentButton.init();
  }
}


function waitForProductItem(cb, tries = 0) {
  if (window.ProductItem_ProductItem) {
    cb();
    return;
  }

  if (tries > 40) {
    console.warn('ProductItem_ProductItem still missing after waiting');
    return;
  }

  setTimeout(function () {
    waitForProductItem(cb, tries + 1);
  }, 100);
}

function initProductCards(root) {
  if (!root) return;

  // Clean previous instances if we re-render
  if (root._customRecProductItems && root._customRecProductItems.length) {
    root._customRecProductItems.forEach(function (instance) {
      if (instance && typeof instance.unload === 'function') {
        instance.unload();
      }
    });
  }

  var els = root.querySelectorAll('[data-product-item]');
  if (!els.length) return;

  if (typeof window.ProductItem_ProductItem === 'undefined') {
    console.warn('ProductItem_ProductItem is not defined on window');
    return;
  }

  var instances = [];
  els.forEach(function (el) {
    instances.push(new window.ProductItem_ProductItem(el));
  });

  root._customRecProductItems = instances;
}



function escapeHtml(s) {
  return s
    ? s.replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;')
    : '';
}

window.CustomRecommendations = {
  getRecommendations,
  renderRecommendationsInto
};
